import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';

import { Badge } from 'src/registry/ui/Badge';
import { DropdownMenuCheckboxItem } from 'src/registry/ui/DropdownMenu';

import type { BadgeOptions, Option } from 'src/registry/types/badges';

type DataTableMultiDropdownProps = {
    getFilterValue: () => string[] | undefined;
    setFilterValue: (v: string[] | undefined) => void;
    options?: Option[];
    badgeOptions?: BadgeOptions;
};
export default function DataTableMultiDropdown({
    options,
    getFilterValue,
    setFilterValue,
    badgeOptions,
}: DataTableMultiDropdownProps) {
    const { formatMessage } = useIntl();

    return (
        <div className="max-h-52 overflow-auto">
            {options &&
                options.map((option) => (
                    <DropdownMenuCheckboxItem
                        checked={(getFilterValue() || []).includes(option.value)}
                        onCheckedChange={(checked) => {
                            const columnValues = getFilterValue();

                            if (!columnValues) {
                                return setFilterValue([option.value]);
                            }
                            if (!checked) {
                                const filterValue =
                                    columnValues && columnValues.length > 1
                                        ? columnValues.filter((colVal) => colVal !== option.value)
                                        : undefined;

                                return setFilterValue(filterValue);
                            }

                            setFilterValue([...columnValues, option.value]);
                        }}
                        onSelect={(e) => e.preventDefault()}
                        key={option.value}
                    >
                        {option.label}
                    </DropdownMenuCheckboxItem>
                ))}
            {badgeOptions &&
                Object.entries(badgeOptions).map(([key, value]) => {
                    const { iconColor, ...colors } = value.color ?? {};
                    return (
                        <DropdownMenuCheckboxItem
                            checked={(getFilterValue() || []).includes(key)}
                            onCheckedChange={(checked) => {
                                const columnValues = getFilterValue();

                                if (!columnValues) {
                                    return setFilterValue([key]);
                                }
                                if (!checked) {
                                    const filterValue =
                                        columnValues && columnValues.length > 1
                                            ? columnValues.filter((colVal) => colVal !== key)
                                            : undefined;

                                    return setFilterValue(filterValue);
                                }

                                setFilterValue([...columnValues, key]);
                            }}
                            onSelect={(e) => e.preventDefault()}
                            key={key}
                        >
                            <Badge theme={value.theme} className="gap-1.5" style={colors}>
                                {value.icon && (
                                    <FontAwesomeIcon
                                        icon={value.icon}
                                        style={{ color: iconColor }}
                                        size={value.iconSize}
                                    />
                                )}
                                {formatMessage(value.label)}
                            </Badge>
                        </DropdownMenuCheckboxItem>
                    );
                })}
        </div>
    );
}
